<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-7">
            <h5 class="card-title">{{ inspectionTitle }}</h5>
          </div>
          <div class="col-sm-5 pt-1 text-right">
          </div>
        </div>
      </div>
      <div class="card-body">
        <el-steps :active="activeElementIndex" finish-status="success" align-center>
          <el-step
            v-for="(elem, index) in elements"
            :key="elem.key"
            :status="elem.elementStatus === 'Abgeschlossen' ? 'success' : elem.elementStatus === 'In Arbeit' ? 'process' : 'wait'">
          </el-step>
        </el-steps>
        <div class="row text-center pt-4">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">Parcours</span>
            <h5>{{ parcoursName }}</h5>
          </div>
        </div>
        <div class="row text-center pt-0" v-if="elements.length && elements[activeElementIndex]">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">{{ elements[activeElementIndex].elementType }}</span>
            <h5>{{ elements[activeElementIndex].elementName }}</h5>
          </div>
        </div>
        <div class="row text-center pt-0" v-if="elements.length && elements[activeElementIndex] && elements[activeElementIndex].elementChecks && elements[activeElementIndex].elementChecks.length > 0">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">Prüfkriterien</span>
            <div class="mt-2">
              <el-checkbox-group v-model="elements[activeElementIndex].elementChecksChecked" class="">
                <el-checkbox
                  v-for="check in elements[activeElementIndex].elementChecks"
                  :key="check.key"
                  size="medium"
                  :label="check.checkText"
                  :disabled="false"
                  class="d-block pb-1 mr-0">
                  {{ check.checkText }}
                </el-checkbox>
              </el-checkbox-group>
            </div>


                

          </div>
        </div>
        <div class="row text-center pt-0 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <p-button block type="primary" size="lg" v-if="elements[activeElementIndex].elementDefectsCount == 0" @click="nextElement()" class="mt-3">Prüfung OK</p-button>
            <p-button block type="warning" size="lg" v-if="elements[activeElementIndex].elementDefectsCount > 0" @click="nextElement()" class="mt-3">Keine weiteren Mängel</p-button>
            <p-button block type="danger" size="lg" @click="addDefect()" class="mt-3">Mangel erfassen</p-button>
          </div>
        </div>
        <div class="row text-center pt-4 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <h6>Bekannte Mängel:</h6>
            <span v-if="elements[activeElementIndex].elementDefectsCount == 0" class="text-success"><i>Keine bekannten Mängel.</i></span>
            <ul v-else class="list-unstyled">
              <li v-for="defect in elements[activeElementIndex].elementDefects" :key="defect.key" @click="showDefect(defect)" style="cursor: pointer;" class="pb-1">
                <span class="text-danger"><b>{{ defect.defectTitle }}</b></span> <span> ({{ defect.defectDate }})</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="row text-center pt-2 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <span class="text-muted" v-if="elements[activeElementIndex].elementDefectsCount > 0"><i>Bereits bekannte Mängel müssen nicht erneut erfasst werden.</i></span>
          </div>
        </div>
        <div class="row text-center pt-4 justify-content-around">
          <div class="col-sm-6">
            <p-button block type="default" size="" @click="previousElement()" class="mt-3">Vorheriges Element</p-button>
            <p-button block type="link" size="" @click="backToInspections()" class="mt-3">Zurück zur Übersicht</p-button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Tag, Select, Option, Progress, Steps, Step, CheckboxGroup } from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Progress.name]: Progress,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [CheckboxGroup.name]: CheckboxGroup,
  },

  data() {
    return {
      loading: true,
      role: store.getters.userrole,
      location: store.getters.userlocation,
      user: store.getters.user.data.displayName,
      inspectionId: "",
      parcoursId: "",
      elements: [],
      inspectionStatus: "",
      inspectionTitle: "",
      parcoursName: "",
      activeElementIndex: 0,

    };
  },
  created() {
    moment.locale("de");
    this.inspectionId = this.$route.params.inspectionId;
    this.parcoursId = this.$route.params.parcoursId;
    this.loadInspection();
  },
  methods: {
    loadInspection() {
      // get inspection data from firebase
      const inspectionRef = db.collection("constructionInspections").doc(this.inspectionId);
      inspectionRef.onSnapshot((snapshotChange) => {
        const inspectionData = snapshotChange.data();
        this.inspectionStatus = inspectionData.Status;
        this.inspectionTitle = inspectionData.Title;
        // get parcours data
        const parcoursRef = inspectionRef.collection("parcours").doc(this.parcoursId);
        parcoursRef.onSnapshot((parcoursSnap) => {
          const parcoursData = parcoursSnap.data();
          this.parcoursName = parcoursData.Name;
          // get elements data
          const elementsRef = parcoursRef.collection("elements");
          elementsRef.orderBy("elementPosition").onSnapshot((elementsSnapshot) => {
            this.elements = [];
            // Bestimme den Index des ersten nicht abgeschlossenen Elements
            let firstOpenElementIndex = -1;
            let currentIndex = 0;

            elementsSnapshot.forEach((elemDoc) => {
              const elemData = elemDoc.data();
              if (firstOpenElementIndex === -1 && elemData.elementStatus !== 'Abgeschlossen') {
                firstOpenElementIndex = currentIndex;
              }
              const defectsRef = db.collection("constructionDefects");
              const elementDefects = [];
              defectsRef.where('Parcours', '==', this.parcoursName).where('Element', '==', elemData.elementName).where('Status', '!=', 'Erledigt')
                .onSnapshot((defectsSnapshot) => {
                  defectsSnapshot.forEach((defectDoc) => {
                    elementDefects.push({
                      key: defectDoc.id,
                      defectTitle: defectDoc.data().Title,
                      defectPrio: defectDoc.data().Prio,
                      defectDate: moment(new Date(defectDoc.data().Date.seconds * 1000)).format("DD.MM.yyyy").toString(),
                      defectStatus: defectDoc.data().Status,
                      defectDescription: defectDoc.data().Description,
                      defectPhotos: defectDoc.data().Photos,
                    });
                  });
                  this.elements.push({
                    key: elemDoc.id,
                    elementName: elemData.elementName,
                    elementStatus: elemData.elementStatus,
                    elementPosition: elemData.elementPosition,
                    elementType: elemData.elementType,
                    elementChecks: elemData.elementChecks || [],
                    elementChecksChecked: elemData.elementChecksChecked || [],
                    elementDefects: elementDefects,
                    elementDefectsCount: elementDefects.length,
                    elementDefectsAdded: 0,
                  });

                });
              currentIndex++;
            });
            // Setze den aktiven Index auf das erste nicht abgeschlossene Element,
            // oder auf das letzte Element, falls alle abgeschlossen sind
            if (elementsSnapshot.size > 0) {
              if (firstOpenElementIndex !== -1) {
                this.activeElementIndex = firstOpenElementIndex;
              } else {
                this.activeElementIndex = elementsSnapshot.size - 1;
              }
            } else {
              this.activeElementIndex = 0;
            }
            this.loading = false;
          });
        });
      });
    },
    showDefect(defect) {
      router.push({ name: 'DefectDetails', params: { defectId: defect.key, inspectionId: this.inspectionId, parcoursName: this.parcoursName, parcoursId: this.parcoursId, elementName: this.elements[this.activeElementIndex].elementName, mode: 'edit' } });
    },
    backToInspections() {
      router.push({ name: 'Inspections', params: { inspectionId: this.inspectionId } });
    },
    previousElement() {
      if (this.activeElementIndex > 0) {
        this.activeElementIndex--;
      }
    },
    nextElement() {
      if (!this.elements.length || !this.elements[this.activeElementIndex]) {
        return;
      }

      const currentIndex = this.activeElementIndex;
      const currentElement = this.elements[currentIndex];

      // Wenn das aktuelle Element bereits abgeschlossen ist, nur lokal weiterblättern
      if (currentElement.elementStatus === 'Abgeschlossen') {
        if (currentIndex < this.elements.length - 1) {
          this.activeElementIndex = currentIndex + 1;
        } else {
          // Beim letzten Element einfach nichts mehr tun oder ggf. zur Übersicht zurück
          // router.push({ name: 'Inspections', params: { inspectionId: this.inspectionId } });
        }
        return;
      }

      // update element status to 'Abgeschlossen' in firebase
      const inspectionRef = db.collection("constructionInspections").doc(this.inspectionId);
      const parcoursRef = inspectionRef.collection("parcours").doc(this.parcoursId);
      const elementRef = parcoursRef.collection("elements").doc(currentElement.key);
      elementRef.update({
        elementStatus: 'Abgeschlossen',
        elementPruefer: this.user,
      }).then(() => {
        // Wenn dies das letzte Element (im Parcours) ist, Parcours abschließen
        if (currentIndex >= this.elements.length - 1) {
          parcoursRef.update({
            Status: 'Abgeschlossen',
          }).then(() => {
            router.push({ name: 'Inspections', params: { inspectionId: this.inspectionId, parcoursNameDone: this.parcoursName } });
          }).catch((error) => {
            console.error("Error updating parcours status: ", error);
          });
        }
      }).catch((error) => {
        console.error("Error updating element status: ", error);
      });
      
    },
    addDefect() {
      router.push({ name: 'DefectDetails', params: { inspectionId: this.inspectionId, parcoursName: this.parcoursName, parcoursId: this.parcoursId, elementName: this.elements[this.activeElementIndex].elementName, mode: 'new' } });
    },

  },
};
</script>
<style scoped>
::v-deep .el-checkbox__label {
  font-size: 1.2rem !important;
  
}
::v-deep .el-checkbox__input {
  vertical-align: baseline !important;
}
</style>
